// Sesión firmada que entrega el login con PIN (cotizador-dv-backend,
// services/sesion.js). Se manda en cada petición como cabecera x-sesion; n8n
// la reenvía al backend, que con ella sabe quién es el vendedor sin creerle
// al vendedor_id del body.
//
// El vencimiento va dentro del token (sin cifrar, solo firmado): se lee aquí
// para cerrar la sesión ANTES de que el backend la rechace. Si no, al vencer
// n8n devolvería errores genéricos y el vendedor no sabría por qué.

const CLAVE = "cotizador_sesion";
export const EVENTO_VENCIDA = "cotizador:sesion-vencida";

export function vencimientoDe(token: string): number | null {
  try {
    const payload = token.split(".")[0];
    const datos = JSON.parse(
      atob(payload.replace(/-/g, "+").replace(/_/g, "/")),
    ) as { exp?: unknown };
    return typeof datos.exp === "number" ? datos.exp : null;
  } catch {
    return null;
  }
}

export function guardarSesion(token: string) {
  try {
    localStorage.setItem(CLAVE, token);
  } catch {
    // almacenamiento bloqueado: la sesión dura lo que la pestaña
  }
  memoria = token;
}
let memoria: string | null = null;

// Token vigente o null (vencido o ausente). Nunca devuelve uno vencido.
export function leerSesion(ahora = Date.now()): string | null {
  let token = memoria;
  try {
    token = localStorage.getItem(CLAVE);
    // Almacenamiento disponible y sin sesión = se cerró (quizá en otra
    // pestaña): la copia en memoria tampoco vale. Antes se usaba igual y la
    // pestaña seguía logueada después de "Salir" en otra.
    if (token === null) memoria = null;
  } catch {
    // almacenamiento bloqueado: solo queda la copia en memoria
  }
  if (!token) return null;
  const exp = vencimientoDe(token);
  if (!exp || exp <= ahora) {
    borrarSesion();
    return null;
  }
  return token;
}

export function borrarSesion() {
  memoria = null;
  try {
    localStorage.removeItem(CLAVE);
  } catch {
    // nada que borrar
  }
}

// La app escucha este evento para volver al login con un aviso. `motivo`
// "pin" = se cerró a propósito tras cambiar el PIN (el aviso lo dice así).
export function avisarVencida(motivo?: "pin") {
  borrarSesion();
  window.dispatchEvent(new CustomEvent(EVENTO_VENCIDA, { detail: motivo }));
}

// Cerrar sesión (o que venza) en una pestaña la cierra en todas: el evento
// `storage` llega a las otras pestañas del mismo origen.
if (typeof window !== "undefined")
  window.addEventListener("storage", (e) => {
    if (e.key === CLAVE && !e.newValue) {
      memoria = null;
      window.dispatchEvent(new Event(EVENTO_VENCIDA));
    }
  });
